<template>
  <v-card v-if="accountData != null" flat class="pa-3">
    <v-card-text class="d-flex">
      <div>
        <avatar-image-component
          :create="true"
          :user="accountData"
          @avatar="accountData.avatar = $event"
        ></avatar-image-component>
      </div>
    </v-card-text>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        class="multi-col-validation mt-6"
        lazy-validation
      >
        <v-row>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="accountData.name"
              :label="$t('forms.name')"
              dense
              outlined
              required
              :rules="nameRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.email"
              :label="$t('forms.email')"
              dense
              outlined
              required
              :rules="emailRules"
              ref="emailField"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.password"
              :label="$t('forms.password')"
              type="password"
              dense
              outlined
              required
              :rules="passwordRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.password_confirmation"
              :label="$t('forms.confirm_password')"
              type="password"
              dense
              outlined
              required
              :rules="passwordConfirmationRules"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              disabled
              v-model="accountData.role_id"
              dense
              outlined
              :label="$t('forms.role')"
              :items="roles"
              item-text="role"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-autocomplete
              v-model="accountData.parent_ids"
              :items="guardians"
              item-text="name"
              item-value="id"
              dense
              outlined
              multiple
              :label="$t('forms.parent')"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              v-model="accountData.status_id"
              :disabled="accountData.id == 1"
              dense
              outlined
              :label="$t('forms.status')"
              :items="statuses"
              item-text="status"
              item-value="value"
            ></v-select>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="accountData.tel_number"
              outlined
              dense
              :label="$t('forms.phone')"
              :rules="phoneRules"
              ref="phoneField"
            ></v-text-field>
          </v-col>

          <!--          <v-col cols="12" md="6" v-if="userType == 'student'">-->
          <!--            <v-text-field-->
          <!--              v-model="accountData.student_identification"-->
          <!--              outlined-->
          <!--              dense-->
          <!--              label="Student ID"-->
          <!--            ></v-text-field>-->
          <!--          </v-col>-->

          <!--          <v-col-->
          <!--            v-else-if="-->
          <!--              userType == 'school' ||-->
          <!--              (userType == 'guardian' && accountData.role_id == 4)-->
          <!--            "-->
          <!--          >-->
          <!--            <v-text-field-->
          <!--              v-model="accountData.balance"-->
          <!--              :disabled="userType == 'guardian' && accountData.role_id == 4"-->
          <!--              outlined-->
          <!--              dense-->
          <!--              label="Balance"-->
          <!--            ></v-text-field>-->
          <!--          </v-col>-->

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-autocomplete
              v-model="accountData.student_school_id"
              :items="schools"
              item-text="name"
              item-value="id"
              dense
              outlined
              :label="$t('forms.school')"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-autocomplete
              v-model="accountData.group_id"
              :items="groups"
              item-text="name"
              item-value="id"
              dense
              outlined
              :label="$t('forms.class')"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <t-time-field
              outlined
              :label="$t('forms.time_from')"
              v-model="accountData.time_from"
              append-icon="mdi-calendar"
              readonly
            ></t-time-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <t-time-field
              outlined
              :label="$t('forms.time_to')"
              v-model="accountData.time_to"
              append-icon="mdi-calendar"
              readonly
            ></t-time-field>
          </v-col>

          <v-col cols="12" md="6" v-if="userType === 'student'">
            <v-textarea
              outlined
              name="input-7-4"
              :label="$t('forms.address')"
              v-model="accountData.address"
              rows="2"
            ></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" class="me-3 mt-4" @click="saveUser">
              {{ $t('actions.save') }}
            </v-btn>
            <v-btn color="secondary" outlined class="mt-4" @click="cancel">
              {{ $t('actions.cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import AvatarImageComponent from '@/components/AvatarImageComponent.vue';
import TTimeField from '@/layouts/components/t-time-field/t-time-field.vue';

export default {
  components: { TTimeField, AvatarImageComponent },
  props: {
    accountData: {
      type: Object,
      default: () => {},
    },
    userType: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return {
      valid: true,
      nameRules: [(v) => !!v || this.$t('forms.name_is_required')],
      // emailRules: [
      //   (v) => !!v || 'E-mail is required',
      //   (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      // ],
      emailRules: [],
      passwordRules: [
        (v) => !!v || this.$t('forms.password_is_required'),
        (v) =>
          (!!v && v?.length > 5) || this.$t('forms.password_min_6_characters'),
      ],
      passwordConfirmationRules: [
        (v) => !!v || this.$t('forms.confirm_password_is_required'),
        (v) =>
          v?.trim() === this.accountData.password?.trim() ||
          this.$t('forms.confirm_password_should_be_the_same_as_password'),
      ],
      parentRules: [(v) => (Array.isArray(v) ? v.length > 0 : !!v) || this.$t('forms.parent_is_required')],
      // phoneRules: [
      //   (v) => !!v || 'Phone is required',
      //   (v) => /^(|\d)+$/.test(v) || 'Phone must be valid',
      // ],
      phoneRules: [],
      statuses: [
        { status: this.$t('table.active'), value: 1 },
        { status: this.$t('table.suspended'), value: 3 },
      ],
      roles: [
        { role: 'Admin', value: 1 },
        { role: 'School', value: 2 },
        { role: 'Driver', value: 3 },
        { role: 'Parent', value: 4 },
        { role: 'Guardian', value: 5 },
        { role: 'Student', value: 6 },
      ],
      guardians: [],
      schools: [],
      groups: [],
    };
  },
  mounted() {
    if (this.userType === 'student') {
      this.getAllGuardiansList();
      this.getAllSchoolsList();
    }
    this.updateContactRules();
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    updateContactRules() {
      const hasEmail = !!this.accountData?.email;
      const hasPhone = !!this.accountData?.tel_number;

      this.emailRules = [
        (v) => {
          if (!v && !hasPhone)
            return this.$t('forms.either_email_or_phone_is_required');
          return true;
        },
        (v) =>
          !v || /.+@.+\..+/.test(v) || this.$t('forms.e_mail_must_be_valid'),
      ];

      this.phoneRules = [
        (v) => {
          if (!v && !hasEmail)
            return this.$t('forms.either_email_or_phone_is_required');
          return true;
        },
        (v) => !v || /^\d+$/.test(v) || this.$t('forms.phone_must_be_numeric'),
      ];

      this.$nextTick(() => {
        this.$refs.emailField?.validate?.();
        this.$refs.phoneField?.validate?.();
      });
    },
    getAllGuardiansList() {
      axios.get(`/users/all-guardians/list`).then((response) => {
        this.guardians = response.data;
      });
    },
    getAllSchoolsList() {
      axios.get(`/schools/list`).then((response) => {
        this.schools = response.data;
      });
    },
    getAllGroupsList(school_id) {
      axios.get(`/classes/list?school_id=${school_id}`).then((response) => {
        this.groups = response.data;
      });
    },
    saveUser() {
      const valid = this.validate()
      if (!valid) {
        if (!this.accountData.name) {
          this.$notify({ title: 'Gabim', text: 'Fusha Emri është e detyrueshme', type: 'error' })
        } else if (!this.accountData.email && !this.accountData.tel_number) {
          this.$notify({ title: 'Gabim', text: 'Duhet të plotësoni Email-in ose Telefonin', type: 'error' })
        } else if (this.accountData.email && !/.+@.+\..+/.test(this.accountData.email)) {
          this.$notify({ title: 'Gabim', text: 'Email-i nuk është i vlefshëm', type: 'error' })
        } else if (!this.accountData.password) {
          this.$notify({ title: 'Gabim', text: 'Fusha Fjalëkalimi është e detyrueshme', type: 'error' })
        } else if (this.accountData.password && this.accountData.password.length < 6) {
          this.$notify({ title: 'Gabim', text: 'Fjalëkalimi duhet të ketë minimumi 6 karaktere', type: 'error' })
        } else if (this.accountData.password !== this.accountData.password_confirmation) {
          this.$notify({ title: 'Gabim', text: 'Konfirmo fjalëkalimin nuk përputhet me fjalëkalimin', type: 'error' })
        } else {
          this.$notify({ title: 'Gabim', text: 'Ju lutemi plotësoni të gjitha fushat e detyrueshme', type: 'error' })
        }
        return
      }
      this.$emit('save-user-info')
    },
    cancel() {
      this.$router.go(-1);
    },
  },
  watch: {
    'accountData.email': 'updateContactRules',
    'accountData.tel_number': 'updateContactRules',
    userType: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue === 'student') {
          this.getAllGuardiansList();
          this.getAllSchoolsList();
        }
      },
    },
    'accountData.student_school_id': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.getAllGroupsList(newValue);
        }
      },
    },
  },
};
</script>

<style lang="scss">
.t-datetime-picker {
  .v-tabs-slider-wrapper {
    top: 0;
  }
  .v-picker__title {
    height: 90px;
  }
  .v-time-picker-title__time * {
    font-size: 60px;
    height: 60px;
  }
  .v-picker__body {
    height: 290px;
  }
  .v-tabs-items {
    height: 380px;
  }
}
</style>
